export const name = 'gzQuickFilter';

/**
 * @ngdoc filter
 * @name gazelle.components.filterBox.quickFilter.filter:gzQuickFilter
 * @function
 *
 * @description
 * Filters an array of objects with particular fields using a case insenstive match.
 * The simple angular filter "filter" will check all fields,
 * which leads to goofy matches like "ff" matching a user's ID and showing the user in a list.
 * (Tied into filter-box module because the two will usually be used together.)
 *
 * @param {string} searchText text to search for
 * @param {string[]} propertyNames array of property names to match (can use '.' notation for nested properties such as 'address.country')
 *
 * @returns {Object[]} containing specified properties that match the search text
 *
 * @example
 * HTML
 * ```html
 * <tr ng-repeat="user in users.userList.users | gzQuickFilter:vm.searchText:['displayName', 'firstName', 'lastName']"></tr>
 * ```
 */
export default function gzQuickFilterFactory() {
  return qzQuickFilter;

  function qzQuickFilter(inputObjects, searchText, propertyNames) {
    if(!searchText) {
      return inputObjects;
    }
    if(!_.isArray(inputObjects)) {
      return inputObjects;
    }
    if(!_.isArray(propertyNames)) {
      return inputObjects;
    }

    // case-insensitive search
    searchText = searchText.toLowerCase();

    return _.filter(inputObjects, input => {
      return _.some(propertyNames, property => {
        let propertyValue = _.get(input, property);
        if(!_.isString(propertyValue)) {
          return false;
        }
        return _.includes(propertyValue.toLowerCase(), searchText);
      });
    });
  }
}
